import { selector } from 'recoil';
import remotePickMealPointsListAtom from '~/recoil/atom/remotePickMealPointsList';
import platformAtom from '../atom/platform';

import { RemotePickMealPointWithId } from '~/types/platform/remotePickMealPoint';

const displayPickMealPointList = selector<RemotePickMealPointWithId[]>({
  key: 'displayPickMealPointList',
  get: ({ get }) => {
    const platform = get(platformAtom);
    const remotePickMealPointsList = get(remotePickMealPointsListAtom);

    const pickMealPointList = remotePickMealPointsList.filter(({ id }) =>
      platform.remotePickMealPoints.includes(id),
    );

    return pickMealPointList;
  },
});

export default displayPickMealPointList;
